// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n8rhU","left":"styles_left__1UEsa","desktopActions":"styles_desktopActions__1Ygf-","title":"styles_title__3DR88"};